import * as Yup from 'yup'

export default Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório!'),
    description: Yup.string(),
    validUntil: Yup.date().required('Validade é obrigatório!'),
    isDefaultTable: Yup.bool().default(false),
    plans: Yup.array()
        .of(Yup.number())
        .min(1, 'Pelo menos um plano deve ser selecionado!')
        .required('Pelo menos um plano deve ser selecionado!')
})